module.exports = __webpack_public_path__ + "img/brand.a2ceca17.svg";